module.exports = __webpack_public_path__ + "static/media/googlepodcast.9ec97344.png";